import { useEffect, useState } from 'react';
import type HighchartsType from 'highcharts';

export function useHighchartsModule() {
  const [highcharts, setHighcharts] = useState<typeof HighchartsType | null>(null);

  useEffect(() => {
    let active = true;
    import('highcharts').then((module) => {
      if (active) {
        setHighcharts(module.default);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return highcharts;
}
